import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TaskEmail {
  id: string;
  subject: string | null;
  from_address: string;
  from_name: string | null;
  received_at: string;
  body_text: string | null;
  body_html: string | null;
  is_read: boolean;
  has_attachments: boolean;
  email_account_id: string;
  message_id: string;
}

export function useTaskEmails(taskId: string | null) {
  return useQuery({
    queryKey: ['task-emails', taskId],
    queryFn: async () => {
      if (!taskId) return [];

      const { data, error } = await supabase
        .from('task_email_links')
        .select(`
          email_message_id,
          email_messages (
            id,
            subject,
            from_address,
            from_name,
            received_at,
            body_text,
            body_html,
            is_read,
            has_attachments,
            email_account_id,
            message_id
          )
        `)
        .eq('task_id', taskId)
        .order('created_at', { ascending: false });

      if (error) throw error;

      // Extract and flatten email_messages from the links
      const emails = data
        ?.map((link: any) => link.email_messages)
        .filter(Boolean) as TaskEmail[];

      return emails || [];
    },
    enabled: !!taskId,
  });
}
